export const imageAlignment = {
    Left: 'left',
    Right: 'right',
    Under: 'under',
    StretchUnder: 'stretch-under',
    Center: 'center',
};
